import React from 'react';
import PropTypes from 'prop-types';
import OrderImages from '../OrderImages';
import OrderStatus from '../OrderStatus';
import OrderDelivery from '../OrderDelivery';
import OrderInformation from '../OrderInformation';
import './OrderSummary.scss';

const OrderSummary = ({ number, state, items, shipping, href, handleOnClick }) => (
  <a href={href} onClick={handleOnClick} className="order-summary__link">
    <div className="order-summary">
      <OrderImages items={items} />
      <div className="order-summary__content">
        <OrderStatus status={state} />
        <OrderDelivery delivery={shipping.delivery} />
        <OrderInformation items={items} number={number} />
      </div>
    </div>
  </a>
);

OrderSummary.propTypes = {
  number: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  shipping: PropTypes.object.isRequired,
};

export default OrderSummary;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderSummary/OrderSummary.js